import { useFormikContext } from 'formik'
import { Alert, ShowIf } from '@ztechapps/webui.util'
import React from 'react'

export const SuccessAlert = () => {
  const { status } = useFormikContext()

  const submitSuccess = status === 'success'

  return (
    <ShowIf condition={submitSuccess}>
      <Alert type="success">
        <strong>Password was changed successfully! </strong>
        <p>Please sign-in using your new password.</p>
      </Alert>
    </ShowIf>
  )
}
